import { Provider } from '@angular/core';
import { DataTestRunnerQuery } from '../state/data-test-runner.query';
import { DataTestRunnerStore } from '../state/data-test-runner.store';
import { DataTestRunnerService } from './data-test-runner.service';

export function provideDataTestRunner(): Provider[] {
  return [
    {
      provide: DataTestRunnerService,
      useClass: DataTestRunnerService,
    },
    {
      provide: DataTestRunnerStore,
      useClass: DataTestRunnerStore,
    },
    {
      provide: DataTestRunnerQuery,
      useClass: DataTestRunnerQuery,
    },
  ];
}
